'use strict';

function sendStats(category, action, label, value) {

    if(value) {
        
       
            WP.stat.show(wp_sn, {"category": category, "label": label, "value": value, "asproduct": asproduct, "asorderid": asorderid, "asname": asname }, action);
            ga('send', 'event', category, action + '-' + value, label);
            ga('extra.send', 'event', category, action + '-' + value, label);
            console.log(category + ', ' +action + ", " +label + ", " + value + ", asproduct:" + asproduct + ", asorderid: " + asorderid + ", asname: " + asname);
    }
    else {
        
            WP.stat.show(wp_sn, {"category": category, "label": label, "asproduct": asproduct, "asorderid": asorderid, "asname": asname }, action);
            ga('send', 'event', category, action, label);
            ga('extra.send', 'event', category, action, label);
            console.log(category + ', ' +action + ", " +label + ", asproduct:" + asproduct + ", asorderid: " + asorderid + ", asname: " + asname);
     }
}